import { SCROLL_ANIMATION_TIMEOUT_MS } from "@/common/constants";

export const ScrollMixin = {
  methods: {
    moveToAnchor(event, id, offset = 0) {
      event.preventDefault();

      const element = document.getElementById(id);

      return new Promise((resolve, reject) => {
        this.smoothScroll(element, offset).then(() => {
          resolve()
        }).catch((error) => {
          reject(error)
        });
      });
    },

    smoothScroll(elem, offset = 0) {
      const rect = elem.getBoundingClientRect();
      let targetPosition = Math.floor(rect.top + window.pageYOffset + offset);
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      });

      return new Promise((resolve, reject) => {
        const failed = setTimeout(() => {
          const biggestHeight = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
          const reachedBottom = biggestHeight + window.innerHeight === document.documentElement.offsetHeight;
          if (reachedBottom) {
            console.log(`Aborting smooth scroll after ${SCROLL_ANIMATION_TIMEOUT_MS}ms as it reached the page bottom.`);
            resolve();

            return;
          }

          const reachedTop = window.scrollY === 0;
          if (reachedTop) {
            console.log(`Aborting smooth scroll after ${SCROLL_ANIMATION_TIMEOUT_MS}ms as it reached the page top.`);
            resolve();

            return;
          }

          reject(`Failed to get to position ${targetPosition} within ${SCROLL_ANIMATION_TIMEOUT_MS} milliseconds`);
        }, SCROLL_ANIMATION_TIMEOUT_MS);

        const scrollHandler = () => {
          if (self.pageYOffset === targetPosition) {
            window.removeEventListener("scroll", scrollHandler);
            clearTimeout(failed);
            resolve();
          }
        };

        if (self.pageYOffset === targetPosition) {
          clearTimeout(failed);
          resolve();
        } else {
          window.addEventListener("scroll", scrollHandler);
          elem.getBoundingClientRect();
        }
      });
    },
  },
};

export const CollapseMixin = {
  data() {
    return {
      movingScroll: false,
    };
  },

  mixins: [ScrollMixin],

  methods: {
    goToCollapse(event, id, ref, offset = -75) {
      if (this.movingScroll) {
        return;
      }

      this.movingScroll = true;

      this.$refs[ref].expand().then(() => {
        this.moveToAnchor(event, id, offset).catch(() => {
          console.log("Error going to collapse!");
        }).finally(() => {
          this.movingScroll = false;
        });
      }).catch((err) => {
        console.log("Error expanding collapse: " + err);
        this.movingScroll = false;
      });
    },

    goBackToTop(event, ref, offset = 0) {
      if (this.movingScroll) {
        return;
      }

      this.movingScroll = true;

      this.moveToAnchor(event, 'app', offset).then(() => {
        this.$refs[ref].shrink().catch((err) => {
          console.log("Error shrinking collapse: " + err);
        }).finally(() => {
          this.movingScroll = false;
        });
      }).catch((error) => {
        console.log("Error going back to top: " + error);
        this.movingScroll = false;
      });
    },
  },
}
